<template>
  <validation-provider
    :rules="_rules"
    :name="columnInfo.label"
    v-slot="{ validated, touched, passed, errors }"
  >
    <b-form-select
      v-if="columnInfo.visible()"
      v-model="_value"
      data-class="base-select"
      size="sm"
      :disabled="columnInfo.disable() || disabled"
      :id="columnInfo.domainColumnName"
      :name="columnInfo.domainColumnName"
      :state="(state && validated) || (state && touched) ? passed : null"
      :options="options"
      v-bind="$attrs"
      v-on="$listeners"
    />
    <span v-if="errorVisible" class="text-danger">
      {{ errors[0] }}
    </span>
  </validation-provider>
</template>

<script>
export default {
  name: 'BaseSelect',

  inheritAttrs: false,

  props: {
    options: {
      type: Array,
      default: () => [],
    },

    value: {
      type: [String, Number],
      default: null,
    },

    /**
     * 定義情報.
     * @type {Object}
     * @requires
     */
    columnInfo: {
      type: Object,
      required: true,
    },

    /**
     * 入力不可か.
     * @type {Boolean}
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    /**
     * バリデーションチェックの状態を表示するか.
     * @type {Boolean}
     */
    state: {
      type: Boolean,
      default: false,
    },

    validated: {
      type: Boolean,
      default: true,
    },

    touched: {
      type: Boolean,
      default: true,
    },

    passed: {
      type: Boolean,
      default: false,
    },

    /**
     * 入力検証ルール.
     * @type {String}
     */
    rules: {
      type: Array,
      default: () => [],
    },

    /**
     * エラーメッセージを表示するか.
     * @type {Boolean}
     */
    errorVisible: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    _value: {
      get() {
        if (
          this.options.some((option) => {
            // 注意：型変換許容（=== ではなく == を使用）
            if (option.value == this.value) {
              return true
            }
          })
        ) {
          return this.value
        }
        if (this.value !== null) {
          console.error('Invalid data', this.columnInfo.label, this.value)
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this._value = null
        }
        return null
      },

      set(v) {
        if (this.value !== v) this.$emit('input', v)
      },
    },

    /**
     * 入力検証ルール.
     * @return {String}
     */
    _rules() {
      let rules = ''
      this.rules.forEach((element) => {
        if (element == this.INPUT_TYPE_CHECK.REQUIRED) {
          rules += 'required|'
        }
      })
      return rules
    },
  },
}
</script>
